import { Form } from 'antd'
import React, { useState } from 'react'
import { TextAreaRef } from 'antd/es/input/TextArea'
import { useTextAreaCursor } from '../../../../utils/hooks'
import FormulaAddFunctionField from './FormulaAddFunctionField'
import FormulaSourceField from './FormulaSourceField'

interface FormulaAddFunctionAndSourceWrapperProps {
  formulaError?: any
}

const FormulaAddFunctionAndSourceWrapper: React.FC<FormulaAddFunctionAndSourceWrapperProps> = ({ formulaError }) => {
  const form = Form.useFormInstance()
  const [textAreaRef, setTextAreaRef] = useState<TextAreaRef | null>(null)
  const cursor = useTextAreaCursor(textAreaRef)

  return (
    <>
      <FormulaAddFunctionField form={form} formulaError={formulaError} cursor={cursor} />
      <FormulaSourceField form={form} cursor={cursor} textAreaRef={textAreaRef} setTextAreaRef={setTextAreaRef} />
    </>
  )
}

export default FormulaAddFunctionAndSourceWrapper
